import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Boat Trips from Albufeira · Private Yacht · Morningstar";
const DESC =
  "Private boat trips near Albufeira aboard Morningstar — Marina de Vilamoura is 15 minutes away. Benagil cave tour, sunset cruise and full-day Algarve charters, up to 18 guests, crewed and catered.";
const PATH = "/boat-trips-albufeira";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/boat-trips-albufeira")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Boat Trips near Albufeira · Algarve",
        title: "Boat trips from Albufeira aboard ",
        titleAccent: "Morningstar.",
        sub: "A short transfer from Albufeira to Marina de Vilamoura — Benagil caves, Falésia cliffs, Galé and sunset cruises along the central Algarve, fully crewed and catered.",
        ctaPrimary: "View cruises",
        ctaSecondary: "Plan my day",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "boat trips Albufeira, Albufeira boat hire, Albufeira yacht charter, Albufeira to Benagil cave, Algarve cruise from Albufeira",
      altPath: { en: PATH, pt: "/pt/passeios-de-barco-albufeira" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private boat trips from Albufeira",
              description: DESC,
              url: URL,
              itinerary: "Marina de Vilamoura (15 min from Albufeira) → Falésia → Galé → Benagil → swim stop → return.",
              durationHours: 5,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Boat Trips from Albufeira", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});